import React from 'react';
import styled from 'styled-components';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Grid, Typography, Link } from '@material-ui/core';
import hoglogo from '../../assets/img/logo.webp';
import '../../../src/sonic.css';

const StyledItem = styled(Grid)`
  flex-direction: row;
  flex-wrap: nowrap;
  display: flex;
`;

const useStyles = makeStyles((theme) => ({
  footer: {
    position: localStorage.getItem('theme') === 'theme-4' ? 'absolute' : 'relative',
    bottom: '0',
    paddingTop: '15px',
    paddingBottom: '15px',
    width: '100%',
    color: 'white',
    backgroundColor: localStorage.getItem('theme') === 'theme-4' ? '#212121' : '#121212',
    textAlign: 'center',
    height: '1.3rem',
    top: localStorage.getItem('theme') === 'theme-4' ? 'initial' : '-10px',
    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  link: {
    width: '24px',
    height: '24px',
    display: 'inline',
    marginLeft: '20px',
  },

  img: {
    width: '24px',
    height: '24px',
  },
}));

const FooterV2 = () => {
  const classes = useStyles();

  return (
    <footer className="w-full bottom-0 bg-sonic-black z-30">
      <div className="mx-auto container w-full max-w-screen-xl py-12 flex flex-col gap-y-16">
        <div className="flex flex-col gap-y-8 md:flex-row md:justify-between">
          <div className="mb-6 md:mb-0">
            <a href="/">
              <div className="relative w-32 h-8">
                <img
                  alt="Hand of God"
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-contain"
                  style={{position:"absolute",height:"100%",width:"100%",left:"0",top:"0",right:"0",bottom:"0",color:"transparent"}}
                  src={hoglogo}
                />
              </div>
            </a>
          </div>
          <div className="grid grid-cols-2 gap-1 sm:gap-16 sm:flex sm:flex-row">
            <div className="md:text-left">
              <h2 className="mb-6 font-medium text-shade-light">Menu</h2>
              <ul className="text-sonic-white font-medium">
                <li className="mb-4">
                  <a href="/" className="hover:underline">
                    Home
                  </a>
                </li>
                <li className="mb-4">
                  <a href="/elysium" className="hover:underline">
                    Elysium
                  </a>
                </li>
                <li className="mb-4">
                  <a href="/sanctum" className="hover:underline">
                    Sanctum
                  </a>
                </li>
                <li className="mb-4">
                  <a href="/purgatory" className="hover:underline">
                    Purgatory
                  </a>
                </li>
              </ul>
            </div>
            <div className="md:text-left">
              <h2 className="mb-6 font-medium text-shade-light">External</h2>
              <ul className="text-sonic-white font-medium">
                <li className="mb-4">
                  <a href="https://hand-of-god.gitbook.io/hand-of-god" className="hover:underline">
                    Docs
                  </a>
                </li>
                <li className="mb-4">
                  <a href="https://x.com/HandofGodSonic" className="hover:underline">
                    Twitter
                  </a>
                </li>
                <li className="mb-4">
                  <a href="https://x.com/GodSonic_AI" className="hover:underline">
                    GOD_AI Twitter
                  </a>
                </li>
                <li className="mb-4">
                  <a href="https://dune.com/hand_of_god/hand-of-god-overview" className="hover:underline">
                    Dune Dashboard
                  </a>
                </li>
                <li className="mb-4">
                  <a href="https://t.me/HandofGodSonic" className="hover:underline">
                    Telegram
                  </a>
                </li>
                <li className="mb-4">
                  <a href="https://discord.gg/q9rzSuKJdY" className="hover:underline">
                    Discord
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="sm:flex sm:items-center sm:justify-between">
          <span className="text-body-sm text-gray-500 sm:text-center dark:text-gray-400">
            © 2025 Hand Of God. All Rights Reserved.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default FooterV2;
